import CircularPercentage from './CircularPercentage'

export default CircularPercentage
